import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
	import { playNotificationSound, unlockAudio } from '../utils/notificationSound';
import { MoreHorizontal, Star, Gift, ChevronDown, ChevronUp, Zap, Play, Calendar, Award, X, Check, Search, Upload, Clock, ShoppingBag, Edit, Loader } from 'lucide-react';

// Canvas-style social media icons
const Facebook = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
);

const Instagram = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="url(#igGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <defs>
      <linearGradient id="igGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f09433" />
        <stop offset="25%" stopColor="#e6683c" />
        <stop offset="50%" stopColor="#dc2743" />
        <stop offset="75%" stopColor="#cc2366" />
        <stop offset="100%" stopColor="#bc1888" />
      </linearGradient>
    </defs>
    <rect width="24" height="24" x="0" y="0" rx="6" ry="6"/>
    <circle cx="12" cy="12" r="4"/>
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
  </svg>
);

const TikTok = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/></svg>
);

const XTwitter = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
);

const WhatsApp = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
);

const LinkedIn = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#0A66C2"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
);

const Phone = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#E3425C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
);

const Mail = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#E3425C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
);

const MapPin = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#E3425C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
);

function useInView(options = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px', ...options });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
}

const C = {
  coral: '#E3425C',
  coralDark: '#D13A4F',
  coralLight: '#F8E0E3',
  charcoal: '#1C1C1E',
  charcoalMid: '#2C2C2E',
  charcoalSoft: '#3A3A3C',
  gold: '#C9A84C',
  goldDark: '#A8872E',
  cream: '#FAFAF9',
  white: '#FFFFFF',
  gray: '#888888',
};

const EVENT_IMAGES = [
  '/hero/wedding.jpg',
  '/hero/birthday.jpg',
  '/hero/lobola.jpg',
  '/hero/gift.jpg',
  '/hero/reception.jpg',
  '/hero/black-wedding.jpg',
];

function Reveal({ children, delay = 0, style = {} }) {
  const [ref, inView] = useInView();
  return (
    <div ref={ref} style={{ ...style, opacity: inView ? 1 : 0, transform: inView ? 'translateY(0)' : 'translateY(30px)', transition: `opacity 0.8s cubic-bezier(0.16,1,0.3,1) ${delay}s, transform 0.8s cubic-bezier(0.16,1,0.3,1) ${delay}s` }}>
      {children}
    </div>
  );
}

function Counter({ target, suffix = '' }) {
  const [ref, inView] = useInView();
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const duration = 2000;
    const start = performance.now();
    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(update);
      else setValue(target);
    }
    requestAnimationFrame(update);
  }, [inView, target]);
  return <span ref={ref}>{value}{suffix}</span>;
}

export default function Landing() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [gigiOpen, setGigiOpen] = useState(false);
  const [gigiNotif, setGigiNotif] = useState(false);
  const [heroIdx, setHeroIdx] = useState(0);
  const [ctaIdx, setCtaIdx] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const [phoneScreenIdx, setPhoneScreenIdx] = useState(0);
  const [phoneTabIdx, setPhoneTabIdx] = useState(0);
  const [cookieConsent, setCookieConsent] = useState(() => localStorage.getItem('cookie_consent') === 'accepted');
  const [testimonials, setTestimonials] = useState([]);

  const slideTrackRef = useRef(null);

  useEffect(() => {
    fetch('/api/reviews')
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          setTestimonials(data.map(f => ({
            name: f.user_name,
            initial: (f.user_name || 'U')[0].toUpperCase(),
            text: f.message,
            rating: f.rating || 5,
          })));
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const t = setInterval(() => setHeroIdx(i => i + 1), 5000);
    return () => clearInterval(t);
  }, []);

  // Infinite slide: when we hit the clone slide, jump back to 0 without transition
  useEffect(() => {
    if (heroIdx >= EVENT_IMAGES.length) {
      const track = slideTrackRef.current;
      if (track) track.style.transition = 'none';
      const raf = requestAnimationFrame(() => {
        setHeroIdx(0);
        requestAnimationFrame(() => {
          if (track) track.style.transition = '';
        });
      });
      return () => cancelAnimationFrame(raf);
    }
  }, [heroIdx]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const t = setInterval(() => setCtaIdx(i => 1 - i), 5000);
    return () => clearInterval(t);
  }, []);

  // Auto-slide phone screens every 5 seconds
  useEffect(() => {
    const t = setInterval(() => setPhoneScreenIdx(i => (i + 1) % 4), 5000);
    return () => clearInterval(t);
  }, []);

  // Auto-slide phone tabs every 3 seconds
  useEffect(() => {
    const t = setInterval(() => setPhoneTabIdx(i => (i + 1) % 3), 3000);
    return () => clearInterval(t);
  }, []);

  // Unlock AudioContext on first user interaction (browser autoplay policy)
  // This way the chime plays simultaneously with GiGi appearing at 6s
  useEffect(() => {
    const unlock = () => {
      unlockAudio();
      document.removeEventListener('click', unlock);
      document.removeEventListener('touchstart', unlock);
      document.removeEventListener('scroll', unlock);
    };
    document.addEventListener('click', unlock);
    document.addEventListener('touchstart', unlock);
    document.addEventListener('scroll', unlock);
    return () => {
      document.removeEventListener('click', unlock);
      document.removeEventListener('touchstart', unlock);
      document.removeEventListener('scroll', unlock);
    };
  }, []);

  // GiGi notification popup — show after 6 seconds with chime
  useEffect(() => {
    const t = setTimeout(() => {
      setGigiNotif(true);
      playNotificationSound();
    }, 6000);
    return () => clearTimeout(t);
  }, []);

  const [activeNav, setActiveNav] = useState(null);

  const scrollTo = (id, label) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setActiveNav(label);
    setMobileOpen(false);
  };

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setCookieConsent(true);
  };

  const navLinks = [
    { label: 'About', href: '/about', color: 'coral' },
    { label: 'Features', id: 'features' },
    { label: 'How It Works', id: 'how-it-works' },
    { label: 'Reviews', id: 'testimonials' },
    { label: 'Contact', href: '/contact' },
  ];

  return (
    <div style={{ fontFamily: 'DM Sans, sans-serif', background: C.cream, overflowX: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Serif+Display&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        ::selection { background: #E3425C; color: white; }
        ::-webkit-scrollbar { width: 8px; }
        ::-webkit-scrollbar-track { background: #FAFAF9; }
        ::-webkit-scrollbar-thumb { background: #ccc; border-radius: 4px; }
        @keyframes floatNotif { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        @keyframes phoneBreath { 0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)} }
        @keyframes storeGloss { 0% { transform: translateX(-100%) skewX(-15deg); } 100% { transform: translateX(300%) skewX(-15deg); } }
        .store-badge::after { content: ''; position: absolute; top: 0; left: 0; width: 60%; height: 100%; background: linear-gradient(90deg, transparent, rgba(255,255,255,0.12), transparent); transform: translateX(-100%) skewX(-15deg); animation: storeGloss 3s ease-in-out infinite; }
        .store-badge:nth-child(2)::after { animation-delay: 1.5s; }
        @keyframes panelIn { from { opacity: 0; transform: translateY(20px) scale(0.95); } to { opacity: 1; transform: translateY(0) scale(1); } }
        @keyframes notifSlideIn { from { opacity: 0; transform: translateX(24px) scale(0.92); } to { opacity: 1; transform: translateX(0) scale(1); } }
        @keyframes notifSlideOut { from { opacity: 1; transform: translateX(0) scale(1); } to { opacity: 0; transform: translateX(24px) scale(0.92); } }
        @keyframes notifPulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.03); } }
        @keyframes gigiDotFlicker { 0%,100% { opacity: 0.75; box-shadow: 0 0 4px rgba(16,185,129,0.35); } 50% { opacity: 1; box-shadow: 0 0 10px rgba(16,185,129,0.7); } }
        .ggr-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 1000; transition: background 0.4s ease, box-shadow 0.4s ease, padding 0.3s ease; padding: 18px 0; }
        .ggr-nav.scrolled { background: rgba(255,255,255,0.35); backdrop-filter: blur(20px) saturate(200%); -webkit-backdrop-filter: blur(20px) saturate(200%); box-shadow: 0 1px 0 rgba(255,255,255,0.3), inset 0 1px 0 rgba(255,255,255,0.2); border-bottom: 1px solid rgba(255,255,255,0.15); padding: 12px 0; }
        .ggr-nav:not(.scrolled) { background: transparent; }
        .mobile-nav { position: fixed; inset: 0; z-index: 1001; background: white; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 16px; opacity: 0; pointer-events: none; transition: opacity 0.3s; }
        .mobile-nav.open { opacity: 1; pointer-events: all; }
        .step-connector { position: absolute; top: 76px; right: -28px; width: 32px; height: 2px; background: linear-gradient(90deg, var(--coral), transparent); z-index: 2; }
        .feature-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; background: linear-gradient(90deg, var(--coral), var(--gold)); opacity: 0; transition: opacity 0.3s; }
        .feature-card:hover::before { opacity: 1; }
        @media (max-width: 1024px) {
          .hero-inner { grid-template-columns: 1fr !important; text-align: center; }
          .hero-left { padding-right: 0 !important; order: 2; }
          .hero-right { order: 1; margin-bottom: 32px; }
          .hero-subtitle { margin-left: auto; margin-right: auto; }
          .hero-ctas { justify-content: center; }
          .hero-stats { justify-content: center; }
          .steps-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .features-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .biz-model-grid { grid-template-columns: repeat(3, 1fr) !important; }
          .trust-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
          .comparison-grid { grid-template-columns: 1fr !important; }
          .comparison-divider { display: none !important; }
          .step-connector { display: none !important; }
          .platform-showcase { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 1024px) {
          .hero-section { min-height: 85vh !important; }
        }
        @media (max-width: 768px) {
          .nav-links, .nav-ctas { display: none !important; }
          .mobile-toggle { display: block !important; }
          .phone-mockup { width: 280px; }
          .phone-screen { min-height: 480px; }
          .float-notif { display: none; }
          .trust-grid { grid-template-columns: 1fr !important; }
          .steps-grid { grid-template-columns: 1fr !important; }
          .features-grid { grid-template-columns: 1fr !important; }
          .biz-model-grid { grid-template-columns: 1fr 1fr !important; }
          .footer-grid { grid-template-columns: 1fr !important; }
          .gigi-panel { width: calc(100vw - 24px) !important; right: 12px; bottom: 90px; }
          .platform-stats-row { grid-template-columns: repeat(2, 1fr) !important; }
          .problem-section, .how-section, .features-section, .business-model-section { padding: 60px 0 !important; }
          .partners-section, .testimonials-section { padding: 50px 0 !important; }
          .cta-section { padding: 60px 0 !important; }
          .testimonial-card { min-width: 280px !important; max-width: 280px !important; }
        }
        @media (max-width: 480px) {
          .ggr-nav { padding: 18px 16px; }
          .mobile-toggle { right: 16px; display: block !important; }
          .nav-links, .nav-ctas { display: none !important; }
          .nav-mobile-ctas { display: flex !important; }
          .hero-inner {
            grid-template-columns: 1fr !important;
            text-align: center;
          }
          .hero-left {
            padding-right: 0 !important;
            padding-left: 0 !important;
            order: 2;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            max-width: 100%;
          }
          .hero-right {
            order: 1;
            margin-bottom: 32px;
            width: 100%;
          }
          .hero-stats { justify-content: center; }
          .hero-ctas { justify-content: center; }
          .phone-mockup { width: 260px !important; }
          .hero-section { min-height: 75vh !important; padding: 100px 0 40px !important; }
          .hero-carousel-img { background-position: center 30% !important; }
          .mobile-download-btn { display: flex !important; }
        }
      `}</style>

      {/* NAV */}
      <nav className={`ggr-nav ${scrolled ? 'scrolled' : ''}`} idmainnav>
        <div style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to ='/' style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
            <img src='/GGR_GiftBox_300dpi-removebg-preview.png' alt='GGR' className="nav-logo" />
          </Link>
          <div className='nav-links' style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {navLinks.map(l => {
              const isBrand = l.color === 'coral';
              const isBlack = l.color === 'black';
              return l.href ? <Link key={l.label} to={l.href} onClick={() => setActiveNav(l.label)} style={{ fontSize: '16px', fontWeight: isBrand ? 700 : isBlack ? 700 : 600, padding: '8px 16px', borderRadius: '8px', color: activeNav === l.label ? '#fff' : isBlack ? '#000' : isBrand ? C.coral : scrolled ? C.charcoalSoft : 'rgba(255,255,255,0.85)', background: activeNav === l.label ? C.coralDark : isBlack ? '#fff' : 'none', textDecoration: 'none', transition: 'all 0.2s', whiteSpace: 'nowrap' }}>{l.label}</Link>
              : <button key={l.label} onClick={() => scrollTo(l.id, l.label)} style={{ fontSize: '16px', fontWeight: isBrand ? 700 : isBlack ? 700 : 600, padding: '8px 16px', borderRadius: '8px', color: activeNav === l.label ? '#fff' : isBlack ? '#000' : isBrand ? C.coral : scrolled ? C.charcoalSoft : 'rgba(255,255,255,0.85)', background: activeNav === l.label ? C.coralDark : isBlack ? '#fff' : 'none', border: activeNav === l.label ? 'none' : isBlack ? '1px solid #ccc' : 'none', cursor: 'pointer', transition: 'all 0.2s', whiteSpace: 'nowrap' }}>{l.label}</button>
            })}

            {/* Download App Dropdown */}
            <div style={{ position: 'relative' }}>
              <button onClick={() => setDownloadOpen(!downloadOpen)} style={{ fontSize: '14px', fontWeight: 600, padding: '8px 18px', borderRadius: '8px', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', background: 'rgba(227,66,92,0.25)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)', border: '1px solid rgba(227,66,92,0.35)', boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.1)', transition: 'all 0.2s', whiteSpace: 'nowrap' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(227,66,92,0.45)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(227,66,92,0.25)'; e.currentTarget.style.transform = ''; }}>
                Download App
                <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' style={{ display: 'inline-block', transition: 'transform 0.3s' }}><path d={downloadOpen ? 'M18 15l-6-6-6 6' : 'M6 9l6 6 6-6'}/></svg>
              </button>
              {downloadOpen && (
                <div style={{ position: 'absolute', top: 'calc(100% + 8px)', right: '0', minWidth: '200px', background: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', borderRadius: '12px', boxShadow: '0 12px 40px rgba(0,0,0,0.25)', border: '1px solid rgba(0,0,0,0.08)', padding: '8px', zIndex: 1100, animation: 'panelIn 0.25s ease' }}>
                  {[
                    { label: 'App Store', sub: 'Coming Soon', icon: <svg width='20' height='20' viewBox='0 0 24 24' fill='white'><path d='M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z'/></svg> },
                    { label: 'Google Play', sub: 'Coming Soon', icon: <svg width='20' height='20' viewBox='0 0 24 24' fill='none'><path d='M3.5 20.5L13.5 12 3.5 3.5v17z' fill='#4285F4'/><path d='M3.5 3.5l10 8.5 3-2.6L3.5 1v2.5z' fill='#EA4335'/><path d='M3.5 20.5L16.5 12l-3-2.5-10 8.5V23l.5-2.5z' fill='#34A853'/><path d='M16.5 9.4L13.5 12l3 2.6L21 12l-4.5-2.6z' fill='#FBBC04'/></svg> },
                  ].map((s, i) => (
                    <a key={i} href="#download" onClick={() => setDownloadOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', transition: 'background 0.2s' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.05)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', borderRadius: '8px', background: 'rgba(0,0,0,0.06)', flexShrink: 0 }}>{s.icon}</div>
                      <div>
                        <div style={{ fontSize: '13px', fontWeight: 600, color: '#1c1c1e', lineHeight: 1.2 }}>{s.label}</div>
                        <div style={{ fontSize: '11px', color: '#999' }}>{s.sub}</div>
                      </div>
                    </a>
                  ))}
                </div>
              )}
            </div>

            {/* Languages Dropdown */}
            <div style={{ position: 'relative' }}>
              <button onClick={() => setLangOpen(!langOpen)} style={{ fontSize: '14px', fontWeight: 600, padding: '8px 10px', borderRadius: '8px', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', background: langOpen ? 'rgba(227,66,92,0.45)' : 'rgba(227,66,92,0.25)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)', border: '1px solid rgba(227,66,92,0.35)', boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.1)', transition: 'all 0.2s', whiteSpace: 'nowrap' }}
                onMouseEnter={e => { if (!langOpen) { e.currentTarget.style.background = 'rgba(227,66,92,0.45)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}}
                onMouseLeave={e => { if (!langOpen) { e.currentTarget.style.background = 'rgba(227,66,92,0.25)'; e.currentTarget.style.transform = ''; }}}
                title="GiGi speaks 7 languages">
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><circle cx='12' cy='12' r='10'/><line x1='2' y1='12' x2='22' y2='12'/><path d='M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z'/></svg>
              </button>
              {langOpen && (
                <div style={{ position: 'absolute', top: 'calc(100% + 8px)', right: '0', minWidth: '220px', background: 'rgba(255,255,255,0.97)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', borderRadius: '12px', boxShadow: '0 12px 40px rgba(0,0,0,0.25)', border: '1px solid rgba(0,0,0,0.08)', padding: '8px', zIndex: 1100, animation: 'panelIn 0.25s ease' }}>
                  <div style={{ padding: '8px 12px 4px', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', color: C.coral }}>GiGi speaks 7 languages</div>
                  {['English', 'isiZulu', 'Setswana', 'Sepitori', 'Sesotho', 'isiXhosa', 'Afrikaans'].map((lang, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 12px', borderRadius: '6px', fontSize: '13px', fontWeight: 500, color: C.charcoal, cursor: 'default' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(227,66,92,0.06)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      {lang}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className='nav-ctas' style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Link to='/login' style={{ padding: '9px 20px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, textDecoration: 'none', transition: 'all 0.25s', color: scrolled ? C.charcoal : 'white', border: scrolled ? '1px solid rgba(0,0,0,0.15)' : '1px solid rgba(255,255,255,0.35)', background: 'transparent' }}>Login</Link>
            <Link to='/register' style={{ padding: '9px 20px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '6px', background: C.coral, color: 'white', boxShadow: '0 2px 12px rgba(227,66,92,0.25)', transition: 'all 0.25s' }}>Sign Up &#8594;</Link>
          </div>
          <button className='mobile-toggle' onClick={() => setMobileOpen(true)} style={{ display: 'none', background: 'none', border: 'none', padding: '8px', color: scrolled ? C.charcoal : 'white', cursor: 'pointer' }}>
            <span style={{ display: 'block', width: '22px', height: '2px', background: 'currentColor', margin: '5px 0', borderRadius: '2px' }} />
            <span style={{ display: 'block', width: '22px', height: '2px', background: 'currentColor', margin: '5px 0', borderRadius: '2px' }} />
            <span style={{ display: 'block', width: '22px', height: '2px', background: 'currentColor', margin: '5px 0', borderRadius: '2px' }} />
          </button>
          {/* Mobile Login/Sign Up buttons */}
          <div className='nav-mobile-ctas' style={{ display: 'none', gap: '8px', alignItems: 'center' }}>
            <Link to='/login' style={{ padding: '10px 16px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, textDecoration: 'none', color: C.charcoal, border: '1px solid rgba(0,0,0,0.15)', background: 'white' }}>Login</Link>
            <Link to='/register' style={{ padding: '10px 16px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, textDecoration: 'none', color: 'white', background: C.coral }}>Sign Up</Link>
          </div>
        </div>
      </nav>

      {/* MOBILE NAV */}
      <div className={`mobile-nav ${mobileOpen ? 'open' : ''}`} style={{}}>
        <button onClick={() => setMobileOpen(false)} style={{ position: 'absolute', top: '20px', right: '20px', background: 'none', border: 'none', fontSize: '36px', color: C.charcoal, cursor: 'pointer', padding: '8px', lineHeight: '1', borderRadius: '50%' }}>&#215;</button>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', marginBottom: '16px' }}>
          {navLinks.map(l => {
            const isBlack = l.color === 'black';
            const isCoral = l.color === 'coral';
            return l.href ? <Link key={l.label} to={l.href} onClick={() => { setActiveNav(l.label); setMobileOpen(false); }} style={{ fontSize: '18px', fontWeight: isCoral ? 700 : isBlack ? 700 : 600, color: activeNav === l.label ? '#fff' : isBlack ? '#000' : isCoral ? C.coral : C.charcoal, background: activeNav === l.label ? C.coralDark : 'none', textDecoration: 'none', padding: '8px 20px', borderRadius: '8px' }}>{l.label}</Link>
            : <button key={l.label} onClick={() => { scrollTo(l.id, l.label); setMobileOpen(false); }} style={{ fontSize: '18px', fontWeight: isCoral ? 700 : isBlack ? 700 : 600, color: activeNav === l.label ? '#fff' : isBlack ? '#000' : isCoral ? C.coral : C.charcoal, background: activeNav === l.label ? C.coralDark : isBlack ? '#fff' : 'none', border: activeNav === l.label ? 'none' : isBlack ? '1px solid #ccc' : 'none', cursor: 'pointer', padding: '8px 20px', borderRadius: '8px' }}>{l.label}</button>
          })}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%', maxWidth: '320px' }}>
          <a href="#download" onClick={() => setMobileOpen(false)} className="mobile-download-btn" style={{ display: 'none', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '16px', borderRadius: '12px', background: 'rgba(227,66,92,0.12)', color: C.coral, textAlign: 'center', fontWeight: 600, textDecoration: 'none', border: '1.5px solid rgba(227,66,92,0.25)' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            Download App
          </a>
          <Link to='/login' onClick={() => setMobileOpen(false)} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '16px', borderRadius: '12px', background: 'transparent', color: C.charcoal, textAlign: 'center', fontWeight: 600, textDecoration: 'none', border: '1.5px solid rgba(0,0,0,0.12)' }}>Login</Link>
          <Link to='/register' onClick={() => setMobileOpen(false)} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '16px', borderRadius: '12px', background: C.coral, color: 'white', textAlign: 'center', fontWeight: 600, textDecoration: 'none' }}>Sign Up</Link>
        </div>
      </div>

      {/* HERO */}
      <section className="hero-section" style={{ minHeight: '100vh', position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', padding: '120px 0 60px' }}>
        {/* Sliding image carousel */}
        <div style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
          <div ref={slideTrackRef} style={{ display: 'flex', width: `${(EVENT_IMAGES.length + 1) * 100}%`, height: '100%', transform: `translateX(-${heroIdx * (100 / (EVENT_IMAGES.length + 1))}%)`, transition: 'transform 0.8s cubic-bezier(0.4,0,0.2,1)' }}>
            {[...EVENT_IMAGES, EVENT_IMAGES[0]].map((img, i) => (
              <div key={i} className="hero-carousel-img" style={{ width: `${100 / (EVENT_IMAGES.length + 1)}%`, height: '100%', backgroundImage: `url(${img})`, backgroundSize: 'cover', backgroundPosition: 'center', flexShrink: 0 }} />
            ))}
          </div>
        </div>
        {/* Dark overlay for text readability */}
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(28,28,30,0.72)' }} />

        <div style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 28px', width: '100%', position: 'relative', zIndex: 2, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', alignItems: 'center' }} className='hero-inner'>

          {/* LEFT - Contains all content */}
          <div style={{ paddingRight: '20px' }} className='hero-left'>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '8px 16px', borderRadius: '50px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)', backdropFilter: 'blur(8px)', marginBottom: '24px', animation: 'fadeInUp 0.8s ease both' }}>
              <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: C.coral, boxShadow: '0 0 8px rgba(227,66,92,0.5)' }} />
              <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.65)', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Powered by GiGi AI Event Assistant</span>
            </div>

            <h1 style={{ fontFamily: 'DM Serif Display, serif', fontSize: 'clamp(32px, 4.5vw, 56px)', fontWeight: 400, lineHeight: 1.08, color: 'white', letterSpacing: '-0.02em', marginBottom: '16px', animation: 'fadeInUp 0.8s 0.1s ease both' }}>
              Plan Your Perfect Event —<br /><span style={{ color: C.coral }}>All in One Place</span>
            </h1>

            <p style={{ fontSize: '15px', lineHeight: 1.7, color: 'rgba(255,255,255,0.55)', maxWidth: '480px', marginBottom: '24px', animation: 'fadeInUp 0.8s 0.18s ease both' }}>
              South Africa's AI-powered event management platform. Create stunning invitations, manage gift registries, track RSVPs via WhatsApp, and book trusted vendors — all from one beautiful dashboard.
            </p>

            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '48px', justifyContent: 'center' }} className='hero-ctas' >
              <Link to='/login' style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '15px 28px', background: C.coral, color: 'white', borderRadius: '8px', fontWeight: 600, fontSize: '15px', textDecoration: 'none', boxShadow: '0 4px 20px rgba(227,66,92,0.35)', transition: 'all 0.3s' }}>
                Start Planning Your Event — Free
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><path d='M5 12h14M12 5l7 7-7 7'/></svg>
              </Link>
              <a href="/demo.html" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '15px 28px', background: 'rgba(255,255,255,0.1)', color: 'white', borderRadius: '8px', fontWeight: 600, fontSize: '15px', textDecoration: 'none', border: '1px solid rgba(255,255,255,0.2)', backdropFilter: 'blur(8px)', transition: 'all 0.3s' }}>
                View Live Demo
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><polygon points='5 3 19 12 5 21 5 3'/></svg>
              </a>
            </div>

            <div style={{ display: 'flex', gap: '32px', flexWrap: 'wrap', justifyContent: 'center' }} className='hero-stats'>
              {[{ target: 50, suffix: '+', label: 'Events' }, { target: 48, suffix: '+', label: 'Vendors' }, { target: 173, suffix: '+', label: 'Guests' }].map((s, i) => (
                <div key={i}>
                  <div style={{ fontSize: '30px', fontWeight: 700, color: 'white', fontFamily: 'DM Serif Display, serif', lineHeight: 1 }}><Counter target={s.target} suffix={s.suffix} /></div>
                  <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.35)', marginTop: '4px', textTransform: 'uppercase', letterSpacing: '1.5px', fontWeight: 600 }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT: LIVE PHONE PREVIEW */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }} className='hero-right'>
            <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: '18px', color: 'white', letterSpacing: '-0.01em', marginBottom: '20px', textAlign: 'center' }}>Live App Preview</div>

            <div style={{ position: 'relative', width: '260px', filter: 'drop-shadow(0 40px 70px rgba(0,0,0,0.5))', animation: 'phoneBreath 8s ease-in-out infinite' }} className='phone-mockup'>
              {/* Phone frame */}
              <div style={{ background: '#111', borderRadius: '44px', padding: '12px', border: '3px solid rgba(255,255,255,0.12)', position: 'relative', overflow: 'hidden' }} className='phone-frame'>
                <div style={{ width: '70px', height: '26px', background: '#111', borderRadius: '0 0 20px 20px', margin: '0 auto 8px', position: 'relative', zIndex: 3 }} className='phone-notch' />

                <div style={{ background: '#0D0D10', borderRadius: '30px', overflow: 'hidden', minHeight: '400px', position: 'relative' }} className='phone-screen'>

                  {/* Phone Header */}
                  <div style={{ background: 'linear-gradient(135deg, #E3425C 0%, #D13A4F 100%)', padding: '10px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: 'none' }} className='phone-header'>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ width: '26px', height: '26px', borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 700, color: 'white' }}>G</div>
                      <div>
                        <div style={{ fontSize: '12px', fontWeight: 600, color: 'white' }}>Grand Gather</div>
                        <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.8)' }}>Hi, Thandi!</div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '4px' }}>
                      <button style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', padding: '4px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' }}>🔔</button>
                      <button style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', padding: '4px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' }}>🎁</button>
                    </div>
                  </div>

                  {/* Phone Screen Content - Auto-sliding */}
                  <div style={{ position: 'relative', height: '265px', overflow: 'hidden' }}>

                    {/* Screen 1: Dashboard */}
                    <div style={{
                      position: 'absolute',
                      inset: 0,
                      padding: '12px',
                      transition: 'transform 0.5s ease, opacity 0.3s ease',
                      transform: phoneScreenIdx === 0 ? 'translateX(0)' : 'translateX(100%)',
                      opacity: phoneScreenIdx === 0 ? 1 : 0
                    }}>
                      <div style={{ fontSize: '9px', color: '#E3425C', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '8px' }}>Your Events</div>

                      <div style={{ display: 'flex', gap: '6px', marginBottom: '10px', overflowX: 'auto', paddingBottom: '4px' }}>
                        {['Wedding', 'Lobola', 'Birthday'].map((tab, i) => (
                          <div key={i} style={{
                            padding: '4px 10px',
                            borderRadius: '20px',
                            fontSize: '10px',
                            fontWeight: 600,
                            background: phoneTabIdx === i ? '#E3425C' : 'rgba(255,255,255,0.08)',
                            color: phoneTabIdx === i ? 'white' : 'rgba(255,255,255,0.6)',
                            whiteSpace: 'nowrap'
                          }}>
                            {tab}
                          </div>
                        ))}
                      </div>

                      {/* Event Cards */}
                      {[
                        { icon: '❤', name: 'Lobola Ceremony', date: 'Sat, 26 Apr', progress: 75 },
                        { icon: '💍', name: 'Thandi & Sipho Wedding', date: 'Sat, 10 May', progress: 45 },
                      ].map((e, i) => (
                        <div key={i} style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', padding: '10px', marginBottom: '8px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ width: '30px', height: '30px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', background: 'rgba(227,66,92,0.15)', flexShrink: 0 }}>{e.icon}</div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ fontSize: '12px', fontWeight: 600, color: 'white' }}>{e.name}</div>
                              <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.4)', marginTop: '2px' }}>{e.date}</div>
                            </div>
                            <div style={{ fontSize: '9px', fontWeight: 700, color: '#34D399' }}>{e.progress}%</div>
                          </div>
                          <div style={{ height: '3px', background: 'rgba(255,255,255,0.08)', borderRadius: '2px', marginTop: '8px', overflow: 'hidden' }}>
                            <div style={{ width: e.progress + '%', height: '100%', background: '#E3425C', borderRadius: '2px' }} />
                          </div>
                        </div>
                      ))}

                      {/* Quick Stats */}
                      <div style={{ display: 'flex', gap: '6px' }}>
                        {[
                          { num: '128', label: 'Guests' },
                          { num: '95', label: 'RSVPs' },
                          { num: '12', label: 'Gifts' },
                        ].map((s, i) => (
                          <div key={i} style={{ flex: 1, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '8px', padding: '8px 4px', textAlign: 'center' }}>
                            <div style={{ fontSize: '13px', fontWeight: 700, color: 'white' }}>{s.num}</div>
                            <div style={{ fontSize: '7px', color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase' }}>{s.label}</div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Screen 2: Create Event */}
                    <div style={{
                      position: 'absolute',
                      inset: 0,
                      padding: '12px',
                      transition: 'transform 0.5s ease, opacity 0.3s ease',
                      transform: phoneScreenIdx === 1 ? 'translateX(0)' : 'translateX(-100%)',
                      opacity: phoneScreenIdx === 1 ? 1 : 0,
                      background: '#0D0D10'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                        <button style={{ background: 'transparent', border: 'none', color: 'white', fontSize: '14px', cursor: 'pointer' }}>&#8592;</button>
                        <div style={{ fontSize: '14px', fontWeight: 600, color: 'white' }}>Create Event</div>
                      </div>

                      {/* Form Fields */}
                      {[
                        { label: 'Event Name', placeholder: 'e.g. Thandi & Sipho Wedding' },
                        { label: 'Date', placeholder: 'Select date' },
                      ].map((f, i) => (
                        <div key={i} style={{ marginBottom: '10px' }}>
                          <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.5)', fontWeight: 600, marginBottom: '4px' }}>{f.label}</div>
                          <div style={{
                            background: 'rgba(255,255,255,0.06)',
                            border: '1px solid rgba(255,255,255,0.1)',
                            borderRadius: '8px',
                            padding: '8px 10px',
                            fontSize: '11px',
                            color: 'rgba(255,255,255,0.6)'
                          }}>
                            {f.placeholder}
                          </div>
                        </div>
                      ))}

                      {/* Theme Selection */}
                      <div style={{ marginBottom: '12px' }}>
                        <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.5)', fontWeight: 600, marginBottom: '6px' }}>Choose Theme</div>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          {['❤', '🎂', '🎄'].map((theme, i) => (
                            <div key={i} style={{
                              width: '36px', height: '36px',
                              borderRadius: '8px',
                              background: 'rgba(255,255,255,0.08)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '16px',
                              border: i === 0 ? '2px solid #E3425C' : 'none'
                            }}>{theme}</div>
                          ))}
                        </div>
                      </div>

                      <button style={{
                        width: '100%',
                        padding: '10px',
                        background: 'linear-gradient(135deg, #E3425C, #D13A4F)',
                        color: 'white',
                        borderRadius: '8px',
                        fontSize: '12px',
                        fontWeight: 600,
                        border: 'none',
                        cursor: 'pointer',
                        boxShadow: '0 4px 15px rgba(227,66,92,0.3)'
                      }}>
                        Create Event
                      </button>
                    </div>

                    {/* Screen 3: Gift Registry */}
                    <div style={{
                      position: 'absolute',
                      inset: 0,
                      padding: '12px',
                      transition: 'transform 0.5s ease, opacity 0.3s ease',
                      transform: phoneScreenIdx === 2 ? 'translateX(0)' : 'translateX(100%)',
                      opacity: phoneScreenIdx === 2 ? 1 : 0,
                      background: '#0D0D10'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 600, color: 'white' }}>Gift Registry</div>
                        <button style={{ background: '#E3425C', border: 'none', color: 'white', padding: '4px 8px', borderRadius: '6px', fontSize: '10px', fontWeight: 600, cursor: 'pointer' }}>+ Add</button>
                      </div>

                      {/* Registry Tabs */}
                      <div style={{ display: 'flex', gap: '12px', marginBottom: '10px' }}>
                        {['🎁 Registry', '💵 Cash', '📝 List'].map((tab, i) => (
                          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
                            <div style={{ fontSize: '16px' }}>{tab.split(' ')[0]}</div>
                            <div style={{ fontSize: '10px', fontWeight: 600, color: i === 0 ? 'white' : 'rgba(255,255,255,0.4)' }}>{tab.split(' ')[1]}</div>
                          </div>
                        ))}
                      </div>

                      {/* Gift Items */}
                      {[1, 2].map((item) => (
                        <div key={item} style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', padding: '10px', marginBottom: '6px' }}>
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <div style={{
                              width: '40px', height: '40px',
                              borderRadius: '8px',
                              background: 'linear-gradient(135deg, rgba(227,66,92,0.2), rgba(201,168,76,0.2))',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '18px',
                              flexShrink: 0
                            }}>📦</div>
                            <div style={{ flex: 1 }}>
                              <div style={{ fontSize: '11px', fontWeight: 600, color: 'white' }}>Wedding Gift Set</div>
                              <div style={{ fontSize: '9px', color: '#60A5FA', marginTop: '2px' }}>Woolworths • R2,250</div>
                            </div>
                            <div style={{ fontSize: '9px', fontWeight: 700, color: '#34D399' }}>60%</div>
                          </div>
                        </div>
                      ))}

                      {/* Cash Gift Card */}
                      <div style={{ background: 'linear-gradient(135deg, rgba(16,185,129,0.15), rgba(52,211,153,0.15))', border: '1px solid rgba(16,185,129,0.3)', borderRadius: '12px', padding: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div style={{ fontSize: '18px' }}>💵</div>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '11px', fontWeight: 600, color: '#34D399' }}>Cash Contributions</div>
                            <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.5)', marginTop: '2px' }}>R45,200 collected</div>
                          </div>
                          <div style={{ fontSize: '16px' }}>🎊</div>
                        </div>
                      </div>
                    </div>

                    {/* Screen 4: AI Invitations */}
                    <div style={{
                      position: 'absolute',
                      inset: 0,
                      padding: '12px',
                      transition: 'transform 0.5s ease, opacity 0.3s ease',
                      transform: phoneScreenIdx === 3 ? 'translateX(0)' : 'translateX(-100%)',
                      opacity: phoneScreenIdx === 3 ? 1 : 0,
                      background: '#0D0D10'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                        <button style={{ background: 'transparent', border: 'none', color: 'white', fontSize: '14px', cursor: 'pointer' }}>&#8592;</button>
                        <div style={{ fontSize: '14px', fontWeight: 600, color: 'white' }}>AI Invitations</div>
                      </div>

                      {/* Invitation Preview */}
                      <div style={{
                        background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                        borderRadius: '14px',
                        padding: '12px',
                        marginBottom: '10px',
                        position: 'relative',
                        overflow: 'hidden'
                      }}>
                        <div style={{ textAlign: 'center' }}>
                          <div style={{ fontSize: '18px', marginBottom: '4px' }}>💍</div>
                          <div style={{ fontSize: '18px', fontWeight: 600, color: 'rgba(0,0,0,0.7)', marginBottom: '2px' }}>Wedding</div>
                          <div style={{ fontSize: '10px', color: 'rgba(0,0,0,0.5)' }}>Thandi & Sipho</div>
                          <div style={{ fontSize: '9px', color: 'rgba(0,0,0,0.4)', marginTop: '4px' }}>Sat, 10 May 2026</div>
                        </div>
                      </div>

                      {/* AI Options */}
                      <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.5)', fontWeight: 600, marginBottom: '6px' }}>AI-Powered</div>
                      {[
                        { icon: '🎨', title: 'Design', desc: 'Auto-generate art' },
                        { icon: '📱', title: 'Send', desc: 'WhatsApp & Email' },
                      ].map((opt, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px', background: 'rgba(255,255,255,0.04)', borderRadius: '8px', marginBottom: '5px' }}>
                          <div style={{ fontSize: '16px' }}>{opt.icon}</div>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '11px', fontWeight: 600, color: 'white' }}>{opt.title}</div>
                            <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.4)' }}>{opt.desc}</div>
                          </div>
                          <button style={{ background: '#E3425C', border: 'none', color: 'white', borderRadius: '5px', padding: '4px 7px', fontSize: '12px', cursor: 'pointer' }}>✔</button>
                        </div>
                      ))}
                    </div>

                  </div>

                  {/* Phone Bottom Nav */}
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '6px 14px',
                    background: 'rgba(13,13,16,0.95)',
                    backdropFilter: 'blur(10px)',
                    display: 'flex',
                    justifyContent: 'space-around',
                    borderTop: '1px solid rgba(255,255,255,0.06)'
                  }}>
                    {[
                      { icon: '🏠', label: 'Home', active: phoneScreenIdx === 0 },
                      { icon: '+', label: 'Create', active: phoneScreenIdx === 1 },
                      { icon: '🎁', label: 'Registry', active: phoneScreenIdx === 2 },
                      { icon: '💌', label: 'Invite', active: phoneScreenIdx === 3 },
                    ].map((tab, i) => (
                      <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', cursor: 'pointer', opacity: tab.active ? 1 : 0.4, transition: 'opacity 0.2s' }}>
                        <div style={{ fontSize: '18px' }}>{tab.icon}</div>
                        <div style={{ fontSize: '9px', fontWeight: 600, color: tab.active ? 'white' : 'rgba(255,255,255,0.4)' }}>{tab.label}</div>
                      </div>
                    ))}
                  </div>

                </div>
              </div>
            </div>

            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <div style={{ fontFamily: 'DM Serif Display, serif', fontSize: '32px', color: 'white', letterSpacing: '-0.01em' }}>Plan. <span style={{ color: C.coral, fontWeight: 600 }}>Register.</span> Celebrate.</div>
            </div>

            <div style={{ textAlign: 'center', marginTop: '28px' }}>
              <img src='/gigi-hero.png' alt='GiGi — AI Event Assistant in African traditional attire' style={{ maxWidth: '180px', height: 'auto', filter: 'drop-shadow(0 4px 14px rgba(0,0,0,0.3))' }} />
              <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.55)', marginTop: '10px', fontWeight: 500, letterSpacing: '0.02em' }}>GiGi speaks your language</div>
            </div>
          </div>
        </div>

        {/* Carousel dot indicators */}
        <div style={{ position: 'absolute', bottom: '24px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '10px', zIndex: 10 }}>
          {EVENT_IMAGES.map((_, i) => (
            <button
              key={i}
              onClick={() => setHeroIdx(i)}
              aria-label={`Slide ${i + 1}`}
              style={{
                width: heroIdx % EVENT_IMAGES.length === i ? '24px' : '8px',
                height: '8px',
                borderRadius: '4px',
                background: heroIdx % EVENT_IMAGES.length === i ? C.coral : 'rgba(255,255,255,0.35)',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.4s ease',
                padding: 0,
              }}
            />
          ))}
        </div>
      </section>

      {/* TRUST STRIP */}
      <section style={{ background: C.white, padding: '32px 0', borderTop: '1px solid rgba(0,0,0,0.04)', borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
        <div style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 28px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px' }} className='trust-grid'>
            {[
              { icon: <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/></svg>, text: 'Designed for modern & traditional celebrations' },
              { icon: <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><circle cx='12' cy='12' r='10'/><polyline points='12 6 12 12 16 14'/></svg>, text: 'Built for seamless event experiences' },
              { icon: <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'/><circle cx='9' cy='7' r='4'/><path d='M23 21v-2a4 4 0 0 0-3-3.87'/><path d='M16 3.13a4 4 0 0 1 0 7.75'/></svg>, text: 'Trusted by growing event planners' },
              { icon: <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'/></svg>, text: 'Free to start' },
            ].map((t, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '12px 16px', borderRadius: '14px', transition: 'all 0.3s', cursor: 'default' }}
                onMouseEnter={e => e.currentTarget.style.background = C.cream}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: C.coralLight, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: C.coral }}>{t.icon}</div>
                <div style={{ fontSize: '13px', fontWeight: 600, color: C.charcoal, lineHeight: 1.4 }}>{t.text}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROBLEM / SOLUTION */}
      <section className='problem-section' id='features' style={{ padding: '100px 0', background: C.cream }}>
        <div style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 28px' }}>
          <Reveal>
            <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '3px', color: C.coral, marginBottom: '12px' }}>Why Grand Gather?</div>
            <h2 style={{ fontFamily: 'DM Serif Display, serif', fontSize: 'clamp(30px, 4vw, 46px)', fontWeight: 400, lineHeight: 1.15, color: C.charcoal, marginBottom: '16px' }}>The Old Way vs The GGR Way</h2>
            <p style={{ fontSize: '16px', color: '#666', maxWidth: '540px', lineHeight: 1.7, marginBottom: '56px' }}>We rethought event planning from the ground up. Here's the difference.</p>
          </Reveal>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', gap: '0', alignItems: 'stretch' }} className='comparison-grid'>
            {/* Old Way */}
            <div style={{ borderRadius: '20px', padding: '36px', position: 'relative', overflow: 'hidden', border: '1px solid rgba(0,0,0,0.04)', background: C.white }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '28px' }}>
                <div style={{ fontSize: '11px', fontWeight: 700, width: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: 'rgba(239,68,68,0.1)', color: '#EF4444' }}>A</div>
                <div style={{ fontSize: '20px', fontWeight: 700, color: C.charcoal }}>The Old Way</div>
              </div>
              {[
                'Managing guests across multiple platforms & spreadsheets',
                'Tracking RSVPs manually via calls & text messages',
                'Coordinating vendors through endless WhatsApp threads',
                'Disconnected gift registries across different stores',
                'Forgetting to send reminders & follow-ups',
              ].map((t, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '14px' }}>
                  <div style={{ width: '28px', height: '28px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px', background: 'rgba(239,68,68,0.08)', color: '#EF4444' }}>
                    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><line x1='18' y1='6' x2='6' y2='18'/><line x1='6' y1='6' x2='18' y2='18'/></svg>
                  </div>
                  <div style={{ fontSize: '14px', color: '#555', lineHeight: 1.5, fontWeight: 500 }}>{t}</div>
                </div>
              ))}
            </div>

            {/* Arrow */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 20px' }} className='comparison-divider'>
              <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: `linear-gradient(135deg, ${C.coral}, ${C.coralDark})`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '22px', boxShadow: '0 4px 16px rgba(227,66,92,0.3)' }}>
                <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><path d='M5 12h14M12 5l7 7-7 7'/></svg>
              </div>
            </div>

            {/* New Way */}
            <div style={{ borderRadius: '20px', padding: '36px', position: 'relative', overflow: 'hidden', border: '1px solid rgba(0,0,0,0.04)', background: C.white }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '28px' }}>
                <div style={{ fontSize: '11px', fontWeight: 700, width: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: 'rgba(16,185,129,0.1)', color: '#10B981' }}>B</div>
                <div style={{ fontSize: '20px', fontWeight: 700, color: C.charcoal }}>The GGR Way</div>
              </div>
              {[
                'GiGi bot manages everything from guest lists to updates',
                'AI-designed invitations sent via WhatsApp & email',
                'Automatic reminders & countdown timers',
                'Curated gifting with cash contributions & proof of payment',
                'Vendor marketplace with reviews, quotes & booking',
              ].map((t, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '14px' }}>
                  <div style={{ width: '28px', height: '28px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px', background: 'rgba(16,185,129,0.08)', color: '#10B981' }}>
                    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><polyline points='20 6 9 17 4 12'/></svg>
                  </div>
                  <div style={{ fontSize: '14px', color: '#555', lineHeight: 1.5, fontWeight: 500 }}>{t}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id='how-it-works' style={{ padding: '100px 0', background: C.white }} className='how-section'>
        <div style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 28px' }}>
          <Reveal>
            <div style={{ textAlign: 'center', marginBottom: '56px' }}>
              <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '3px', color: C.coral, marginBottom: '12px' }}>Simple Process</div>
              <h2 style={{ fontFamily: 'DM Serif Display, serif', fontSize: 'clamp(30px, 4vw, 46px)', fontWeight: 400, color: C.charcoal, marginBottom: '16px' }}>How It Works</h2>
              <p style={{ fontSize: '16px', color: '#666', maxWidth: '460px', margin: '0 auto', lineHeight: 1.7 }}>Four steps to your perfect event. That's all it takes.</p>
            </div>
          </Reveal>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px', position: 'relative' }} className='steps-grid'>
            {[
              { icon: <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7'/><path d='M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z'/></svg>, title: 'Create Your Event', desc: 'Set up your event in minutes with our intuitive event builder. Add details, set your theme, and choose your event type.' },
              { icon: <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'/><circle cx='9' cy='7' r='4'/><path d='M23 21v-2a4 4 0 0 0-3-3.87'/><path d='M16 3.13a4 4 0 0 1 0 7.75'/></svg>, title: 'Invite Your Guests', desc: 'Share beautiful AI-designed invitations via WhatsApp or email. Guests RSVP instantly and receive automatic reminders.' },
              { icon: <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><polyline points='20 12 20 22 4 22 4 12'/><rect x='2' y='7' width='20' height='5'/><line x1='12' y1='22' x2='12' y2='7'/><path d='M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z'/><path d='M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z'/></svg>, title: 'Build Your Registry', desc: 'Create your perfect gift registry. Mix physical gifts from any store with cash contributions and instant proof of payment.' },
              { icon: <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><circle cx='12' cy='12' r='3'/><path d='M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z'/></svg>, title: 'Manage Everything', desc: 'Track RSVPs, manage your guest list, send invitations, and handle all communications from one powerful dashboard.' },
            ].map((s, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div style={{ background: C.cream, borderRadius: '20px', padding: '32px 24px', textAlign: 'center', transition: 'all 0.35s cubic-bezier(0.16,1,0.3,1)', position: 'relative', border: '1px solid rgba(0,0,0,0.04)', cursor: 'default' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.12)'; e.currentTarget.style.background = C.white; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; e.currentTarget.style.background = C.cream; }}
                  className='step-card'>
                  <div style={{ width: '52px', height: '52px', borderRadius: '16px', margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', background: `linear-gradient(135deg, ${C.coral}, ${C.coralDark})`, color: 'white', boxShadow: '0 4px 16px rgba(227,66,92,0.25)' }} className='step-num'>{s.icon}</div>
                  <div style={{ fontSize: '17px', fontWeight: 700, color: C.charcoal, marginBottom: '10px' }}>{s.title}</div>
                  <div style={{ fontSize: '14px', color: '#777', lineHeight: 1.6 }}>{s.desc}</div>
                  {i < 3 && <div className='step-connector' />}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section style={{ padding: '100px 0', background: C.cream }} className='features-section'>
        <div style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 28px' }}>
          <Reveal>
            <div style={{ textAlign: 'center', marginBottom: '56px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', flexWrap: 'wrap' }}>
                <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '3px', color: C.coral }}>Everything You Need</div>
                <button onClick={() => setDropdownOpen(!dropdownOpen)} style={{ background: 'transparent', border: '1px solid rgba(227,66,92,0.3)', borderRadius: '8px', padding: '6px 16px', cursor: 'pointer', fontSize: '12px', fontWeight: 600, color: C.coral, display: 'flex', alignItems: 'center', gap: '6px', transition: 'all 0.2s' }}
                  onMouseEnter={e => { e.currentTarget.style.background = C.coralLight; e.currentTarget.style.borderColor = C.coral; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'rgba(227,66,92,0.3)'; }}>
                  {dropdownOpen ? 'Show Less' : 'Show More'}
                  <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={{ transition: 'transform 0.3s' }}><path d={dropdownOpen ? 'M6 9l6 6 6-6' : 'M19 9l-6 6-6-6'}/></svg>
                </button>
              </div>
              <h2 style={{ fontFamily: 'DM Serif Display, serif', fontSize: 'clamp(30px, 4vw, 46px)', fontWeight: 400, color: C.charcoal, marginBottom: '16px' }}>Powerful Features, Beautiful Design</h2>
              <p style={{ fontSize: '16px', color: '#666', maxWidth: '480px', margin: '0 auto', lineHeight: 1.7 }}>Every tool you need to plan, manage, and celebrate — all in one place.</p>
            </div>
          </Reveal>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '28px' }} className='features-grid'>
            {[...Array(9)].map((_, i) => {
              // Show first 3 cards when closed, first 6 when open
              if (!dropdownOpen && i >= 3) return null;
              if (dropdownOpen && i >= 6) return null;
              const features = [
                { iconColor: 'coral', icon: <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><rect x='3' y='3' width='7' height='7'/><rect x='14' y='3' width='7' height='7'/><rect x='14' y='14' width='7' height='7'/><rect x='3' y='14' width='7' height='7'/></svg>, title: 'Smart Dashboard', desc: 'Everything about your event at a glance. Track RSVPs, manage tasks, view gift contributions, and monitor vendor bookings — all from one beautifully organized dashboard.' },
                { iconColor: 'gold', icon: <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'/><circle cx='9' cy='7' r='4'/><path d='M23 21v-2a4 4 0 0 0-3-3.87'/><path d='M16 3.13a4 4 0 0 1 0 7.75'/></svg>, title: 'Guest Management', desc: 'Organize your guest list effortlessly. Track RSVPs in real time, manage plus-ones, dietary requirements, table seating, and send targeted updates to specific groups.' },
                { iconColor: 'charcoal', icon: <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><polyline points='20 12 20 22 4 22 4 12'/><rect x='2' y='7' width='20' height='5'/><line x1='12' y1='22' x2='12' y2='7'/><path d='M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z'/><path d='M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z'/></svg>, title: 'Gift Registry', desc: 'Build the perfect gift registry with items from any store, combined with cash contributions. Receive instant notifications when gifts arrive, with automatic proof of payment.' },
                { iconColor: 'coral', icon: <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'/></svg>, title: 'AI Invitation Designer', desc: 'Create stunning AI-generated invitations in seconds. Choose from dozens of beautiful templates and let GiGi craft personalized messages for any event type.' },
                { iconColor: 'gold', icon: <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'/></svg>, title: 'WhatsApp RSVP', desc: 'Send beautiful WhatsApp invitations and track RSVPs in real-time. Guests respond directly through WhatsApp with automatic updates and reminders.' },
                { iconColor: 'charcoal', icon: <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2'/><circle cx='12' cy='7' r='4'/><path d='M16 11V7a4 4 0 0 0-8 0v4'/><path d='M12 14a7 7 0 0 0-7 7h14a7 7 0 0 0-7-7z'/></svg>, title: 'Vendor Marketplace', desc: 'Book trusted vendors from South Africa. Browse photographers, caterers, venues, and more — all reviewed and verified for your peace of mind.' },
                { iconColor: 'coral', icon: <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'/></svg>, title: 'Budget Tracker', desc: 'Keep your event finances on track with automatic budget tracking. Set spending limits, categorize expenses, and get alerts when over budget.' },
                { iconColor: 'gold', icon: <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z'/></svg>, title: 'Guest Lists & Invites', desc: 'Create guest lists, track who\'s coming, and send digital invitations. Manage dietary requirements, table assignments, and seating arrangements.' },
                { iconColor: 'charcoal', icon: <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z'/></svg>, title: 'Event Documents', desc: 'Create and store all your event documents in one place. Save seating charts, vendor contracts, and important details in a secure cloud database.' },
              ];
              return (
                <Reveal key={i} delay={i * 0.1}>
                  <div style={{ background: C.white, borderRadius: '20px', padding: '40px 32px', border: '1px solid rgba(0,0,0,0.04)', transition: 'all 0.35s cubic-bezier(0.16,1,0.3,1)', position: 'relative', overflow: 'hidden', cursor: 'default' }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 20px 60px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.08)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
                    className='feature-card'>
                    <div style={{ width: '60px', height: '60px', borderRadius: '16px', marginBottom: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '26px', background: features[i].iconColor === 'coral' ? C.coralLight : features[i].iconColor === 'gold' ? 'rgba(201,168,76,0.12)' : 'rgba(28,28,30,0.06)', color: features[i].iconColor === 'coral' ? C.coral : features[i].iconColor === 'gold' ? C.gold : C.charcoal }}>{features[i].icon}</div>
                    <div style={{ fontSize: '20px', fontWeight: 700, color: C.charcoal, marginBottom: '12px' }}>{features[i].title}</div>
                    <div style={{ fontSize: '14px', color: '#666', lineHeight: 1.7, marginBottom: '20px' }}>{features[i].desc}</div>
                    <Link to='/login' style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 600, color: C.coral, textDecoration: 'none', transition: 'gap 0.2s' }}
                      onMouseEnter={e => e.currentTarget.style.gap = '10px'}
                      onMouseLeave={e => e.currentTarget.style.gap = '6px'}>
                      {features[i].title === 'Smart Dashboard' ? 'Explore Dashboard' : features[i].title === 'Guest Management' ? 'Manage Guests' : 'Start Registry'}
                      <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><path d='M5 12h14M12 5l7 7-7 7'/></svg>
                    </Link>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      {/* BUSINESS MODEL */}
      <section style={{ padding: '100px 0', background: C.white }} className='business-model-section'>
        <div style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 28px' }}>
          <Reveal>
            <div style={{ textAlign: 'center', marginBottom: '56px' }}>
              <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '3px', color: C.coral, marginBottom: '12px' }}>How We Sustain It</div>
              <h2 style={{ fontFamily: 'DM Serif Display, serif', fontSize: 'clamp(30px, 4vw, 46px)', fontWeight: 400, color: C.charcoal, marginBottom: '16px' }}>Digital-Native Business Model</h2>
              <p style={{ fontSize: '16px', color: '#666', maxWidth: '560px', margin: '0 auto', lineHeight: 1.7 }}>Multiple revenue streams power a scalable, asset-light platform &mdash; so hosts can start for free while we grow with our vendor partners.</p>
            </div>
          </Reveal>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px', marginBottom: '28px' }} className='biz-model-grid'>
            {[
              { icon: '💼', title: 'Vendor Subscriptions', desc: 'Vendors pay monthly subscription fees to access the platform, list their services, and receive bookings.', price: 'Free – R499/mo', unit: 'Starter (Free) • Pro (R199) • Premium (R499)' },
              { icon: '💳', title: 'Transaction Commissions', desc: 'A platform commission is earned on every vendor booking — the rate decreases as vendors upgrade tiers.', price: '8% / 3% / 0%', unit: 'Starter (8%) • Pro (3%) • Premium (0%)' },
              { icon: '🎁', title: 'Gift Registry Fees', desc: 'A platform fee on gift code transactions generated through the registry, connecting guests with retail partners.', price: '5%', unit: 'per gift transaction' },
              { icon: '🎟️', title: 'Ticket Sales', desc: 'Hosts sell event tickets through the platform. A 3% platform commission plus R3 buyer-paid booking fee is earned on every ticket sold.', price: '3% + R3', unit: 'per ticket sold' },
              { icon: '⚡', title: 'Premium Host Tools', desc: 'Hosts can upgrade to premium event planning features for advanced customisation and priority vendor matching.', price: 'Free • R99 • R199/event', unit: 'Free • Standard (R99) • Premium (R199)' },
              { icon: '📢', title: 'Advertising & Sponsorship', desc: 'Vendors and partners can purchase sponsored placements and featured listings across our marketplace and event pages.', price: 'Monthly placements', unit: 'With impression & click tracking' },
            ].map((item, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div style={{ background: C.cream, borderRadius: '16px', padding: '28px 20px', textAlign: 'center', border: '1px solid rgba(0,0,0,0.04)', transition: 'all 0.35s cubic-bezier(0.16,1,0.3,1)', cursor: 'default' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.1)'; e.currentTarget.style.background = C.white; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; e.currentTarget.style.background = C.cream; }}
                  className='biz-card'>
                  <div style={{ fontSize: '28px', marginBottom: '10px' }}>{item.icon}</div>
                  <div style={{ fontSize: '16px', fontWeight: 700, color: C.charcoal, marginBottom: '8px' }}>{item.title}</div>
                  <div style={{ fontSize: '13px', color: '#666', marginBottom: '14px', lineHeight: 1.5 }}>{item.desc}</div>
                  <div style={{ fontSize: '22px', fontWeight: 700, color: C.coral, marginBottom: '4px' }}>{item.price}</div>
                  <div style={{ fontSize: '11px', color: '#888' }}>{item.unit}</div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div style={{ textAlign: 'center', padding: '20px 28px', background: 'rgba(201,168,76,0.06)', borderRadius: '12px', border: '1px solid rgba(201,168,76,0.15)', maxWidth: '820px', margin: '0 auto' }}>
              <p style={{ fontSize: '14px', color: '#555', margin: 0, lineHeight: 1.6 }}>
                <strong style={{ color: C.charcoal }}>Digital-native, asset-light platform</strong> &mdash; Recurring subscription revenue + transaction-based fees. No physical infrastructure required. Scalable across South Africa's growing event industry (valued at R11 billion annually).
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      {/* PARTNER NETWORK */}
      <section id='partners' style={{ padding: '80px 0', background: C.cream, overflow: 'hidden' }} className='partners-section'>
        <div style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 28px' }}>
          <Reveal>
            <div style={{ textAlign: 'center', marginBottom: '48px' }}>
              <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '3px', color: C.coral, marginBottom: '12px' }}>Partner Network</div>
              <h2 style={{ fontFamily: 'DM Serif Display, serif', fontSize: 'clamp(30px, 4vw, 46px)', fontWeight: 400, color: C.charcoal }}>Trusted Partners Powering Your Events</h2>
              <div style={{ fontSize: '15px', color: '#666', marginTop: '12px', lineHeight: 1.6 }}>We team up with South Africa's most trusted service providers to bring you seamless, end-to-end event experiences.</div>
            </div>
          </Reveal>
          <div className='features-grid' style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' }}>
            {/* Become a Partner CTA */}
            <Reveal>
              <Link to='/partnerships' style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
                <div style={{ background: C.white, borderRadius: '20px', border: `2px dashed ${C.coralLight}`, padding: '40px 32px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', minHeight: '100%', transition: 'all 0.35s cubic-bezier(0.16,1,0.3,1)', cursor: 'pointer' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 20px 60px rgba(0,0,0,0.10), 0 8px 20px rgba(0,0,0,0.05)'; e.currentTarget.style.borderColor = C.coral; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; e.currentTarget.style.borderColor = C.coralLight; }}>
                  <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: C.coralLight, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px', fontSize: '28px', color: C.coral }}>
                    <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><path d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2'/><circle cx='9' cy='7' r='4'/><line x1='19' y1='8' x2='19' y2='14'/><line x1='22' y1='11' x2='16' y2='11'/></svg>
                  </div>
                  <div style={{ fontSize: '20px', fontWeight: 700, color: C.charcoal, marginBottom: '10px' }}>Become a Partner</div>
                  <div style={{ fontSize: '14px', color: '#666', lineHeight: 1.7, marginBottom: '24px' }}>Join our trusted network and reach thousands of event hosts across South Africa. Showcase your services where hosts are already planning.</div>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: C.coral, color: C.white, padding: '14px 28px', borderRadius: '12px', fontSize: '15px', fontWeight: 700, boxShadow: '0 4px 16px rgba(227,66,92,0.4)', transition: 'all 0.2s' }}>
                    Enquire Now
                    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><path d='M5 12h14M12 5l7 7-7 7'/></svg>
                  </span>
                </div>
              </Link>
            </Reveal>
            {/* Empty placeholder for grid balance */}
            <div></div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section id='testimonials' style={{ padding: '80px 0', background: C.white, overflow: 'hidden' }} className='testimonials-section'>
        <div style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 28px' }}>
          <Reveal>
            <div style={{ textAlign: 'center', marginBottom: '48px' }}>
              <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '3px', color: C.coral, marginBottom: '12px' }}>Testimonials</div>
              <h2 style={{ fontFamily: 'DM Serif Display, serif', fontSize: 'clamp(30px, 4vw, 46px)', fontWeight: 400, color: C.charcoal }}>What Our Users Say</h2>
            </div>
          </Reveal>
        </div>
        <div style={{ overflow: 'hidden', position: 'relative' }}>
          <div style={{ display: 'flex', gap: '20px', animation: 'marquee 40s linear infinite', width: 'max-content' }}
            onMouseEnter={e => e.currentTarget.style.animationPlayState = 'paused'}
            onMouseLeave={e => e.currentTarget.style.animationPlayState = 'running'}
            className='marquee-track'>
            {testimonials.length === 0 ? (
              <div style={{ textAlign: 'center', color: '#999', padding: '20px', width: '100%' }}>Reviews coming soon</div>
            ) : [...testimonials, ...testimonials].map((t, i) => (
              <div key={i} style={{ background: C.cream, borderRadius: '20px', padding: '28px', minWidth: '340px', maxWidth: '340px', flexShrink: 0, border: '1px solid rgba(0,0,0,0.04)', transition: 'all 0.3s', cursor: 'default' }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = ''; e.currentTarget.style.transform = ''; }}
                className='testimonial-card'>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px' }}>
                  <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: `linear-gradient(135deg, ${C.coral}, ${C.gold})`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 700, fontSize: '16px', flexShrink: 0 }}>{t.initial}</div>
                  <div><div style={{ fontSize: '15px', fontWeight: 700, color: C.charcoal }}>{t.name}</div></div>
                </div>
                <div style={{ fontSize: '14px', color: '#F59E0B', letterSpacing: '2px', marginBottom: '12px' }}>{'\u2605'.repeat(t.rating)}{'\u2606'.repeat(5 - t.rating)}</div>
                <div style={{ fontSize: '13px', color: '#555', lineHeight: 1.7, fontStyle: 'italic' }}>'{t.text}'</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ position: 'relative', padding: '110px 0', overflow: 'hidden' }} className='cta-section'>
        {EVENT_IMAGES.map((img, i) => (
          <div key={i} style={{ position: 'absolute', inset: 0, backgroundImage: `url(${img})`, backgroundSize: 'cover', backgroundPosition: 'center', opacity: ctaIdx === i ? 1 : 0, transition: 'opacity 1.4s ease-in-out' }} className={`cta-bg cta-bg-${i + 1}${ctaIdx === i ? ' active' : ''}`} />
        ))}
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(28,28,30,0.87)' }} className='cta-overlay' />
        <Reveal>
          <div style={{ maxWidth: '740px', margin: '0 auto', padding: '0 28px', textAlign: 'center', position: 'relative', zIndex: 2 }}>
            <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '3px', color: 'rgba(255,255,255,0.5)', marginBottom: '16px' }}>Start Today</div>
            <h2 style={{ fontFamily: 'DM Serif Display, serif', fontSize: 'clamp(32px, 4vw, 50px)', fontWeight: 400, lineHeight: 1.15, color: 'white', marginBottom: '16px' }}>
              Ready to Plan Your Next<br /><span style={{ color: C.coral }}>Celebration?</span>
            </h2>
            <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.5)', maxWidth: '460px', margin: '0 auto 32px', lineHeight: 1.7 }}>
              Join thousands of hosts and vendors creating beautiful celebrations across South Africa. Free to start, premium when you're ready to scale.
            </p>
            <Link to='/register' style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '17px 36px', background: C.coral, color: 'white', borderRadius: '8px', fontWeight: 600, fontSize: '16px', textDecoration: 'none', boxShadow: '0 4px 20px rgba(227,66,92,0.35)', transition: 'all 0.3s' }}>
              Sign Up Free
              <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><path d='M5 12h14M12 5l7 7-7 7'/></svg>
            </Link>
          </div>
        </Reveal>
      </section>

      {/* FOOTER */}
      <footer style={{ background: C.charcoal, padding: '40px 0 36px' }}>
        <div style={{ maxWidth: '1240px', margin: '0 auto', padding: '0 28px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '48px', marginBottom: '40px' }} className='footer-grid'>
            {/* Brand */}
            <div>
              <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '16px' }}>
                <img src='/ggr-logo-deck.png' alt='Grand Gather Registry' style={{ height: '80px', filter: 'brightness(0) invert(1)' }} />
              </div>
              <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.4)', lineHeight: 1.7, maxWidth: '300px', marginBottom: '20px' }}>
                Seamless Events, Thoughtful Gifting. The smart platform for planning unforgettable celebrations across South Africa.
              </p>

              {/* Store badges */}
              <div id="download" style={{ marginBottom: '24px' }}>
                <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.35)', margin: '0 0 10px', fontFamily: "'DM Serif Display', serif", fontStyle: 'italic' }}>
                  Coming soon on App Store & Google Play
                </p>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {[
                    { label: 'App Store', icon: <svg width='18' height='18' viewBox='0 0 24 24' fill='white'><path d='M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z'/></svg> },
                    { label: 'Google Play', icon: <svg width='18' height='18' viewBox='0 0 24 24' fill='none'><path d='M3.5 20.5L13.5 12 3.5 3.5v17z' fill='#4285F4'/><path d='M3.5 3.5l10 8.5 3-2.6L3.5 1v2.5z' fill='#EA4335'/><path d='M3.5 20.5L16.5 12l-3-2.5-10 8.5V23l.5-2.5z' fill='#34A853'/><path d='M16.5 9.4L13.5 12l3 2.6L21 12l-4.5-2.6z' fill='#FBBC04'/></svg> },
                  ].map((s, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', padding: '8px 14px', borderRadius: '8px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)', transition: 'all 0.3s', cursor: 'default', position: 'relative', overflow: 'hidden' }}
                      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}
                      onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
                      className='store-badge'>
                      <div>{s.icon}</div>
                      <div style={{ fontSize: '11px', color: 'white', fontWeight: 500, whiteSpace: 'nowrap' }}>{s.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Social links */}
              <div style={{ fontSize: '13px', fontWeight: 400, color: '#fff', fontFamily: "'DM Serif Display', serif", textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '16px' }}>Follow Our Social Media</div>
              <div style={{ display: 'flex', gap: '16px' }}>
                {[
                  { href: 'https://www.facebook.com/share/1EYafbaqrq/', icon: <Facebook /> },
                  { href: 'https://www.instagram.com/grand_gather_registry', icon: <Instagram /> },
                  { href: 'https://www.tiktok.com/@grand.gather.regi', icon: <TikTok /> },
                  { href: 'https://x.com/grand_gather', icon: <XTwitter /> },
                  { href: 'https://www.linkedin.com/company/grand-gather-registry/', icon: <LinkedIn /> },
                  { href: 'https://wa.me/27613911942', icon: <WhatsApp /> },
                ].map((s, i) => (
                  <a key={i} href={s.href} target='_blank' rel='noreferrer' style={{ display: 'flex', alignItems: 'center', color: 'white', transition: 'all 0.2s', textDecoration: 'none' }}
                    onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                    onMouseLeave={e => e.currentTarget.style.transform = ''}
                    className='social-link'>
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Company */}
            <div>
              <div style={{ fontSize: '13px', fontWeight: 400, color: '#fff', fontFamily: "'DM Serif Display', serif", textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '16px' }}>Company</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {[['About Us', '/about'], ['Contact', '/contact'], ['Investors & Partnership', '/partnerships', true], ['Careers', '/careers']].map(([label, href, coral]) => (
                  <Link key={label} to={href} style={{ fontSize: '14px', color: coral ? C.coral : 'rgba(255,255,255,0.4)', textDecoration: 'none', padding: '4px 0', transition: 'color 0.2s' }} className={`footer-link${coral ? ' coral' : ''}`}>{label}</Link>
                ))}
              </div>
            </div>

            {/* Support */}
            <div>
              <div style={{ fontSize: '13px', fontWeight: 400, color: '#fff', fontFamily: "'DM Serif Display', serif", textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '16px' }}>Support</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {[['Help Center', '/help'], ['FAQs', '/help'], ['Privacy Policy', '/privacy'], ['Terms of Service', '/terms']].map(([label, href]) => (
                  <Link key={label} to={href} style={{ fontSize: '14px', color: 'rgba(255,255,255,0.4)', textDecoration: 'none', padding: '4px 0', transition: 'color 0.2s' }} className='footer-link'>{label}</Link>
                ))}
                <Link to='/register/vendor' style={{ fontSize: '14px', color: C.gold, textDecoration: 'none', padding: '4px 0', marginTop: '8px', paddingTop: '8px', borderTop: '1px solid rgba(255,255,255,0.06)', transition: 'color 0.2s' }} className='footer-link gold'>Join as Vendor</Link>
                <Link to='/vendor-login' style={{ fontSize: '14px', color: 'rgba(255,255,255,0.4)', textDecoration: 'none', padding: '4px 0', transition: 'color 0.2s' }} className='footer-link'>Vendor Login</Link>
              </div>
            </div>

            {/* Contact */}
            <div>
              <div style={{ fontSize: '13px', fontWeight: 700, color: '#fff', fontFamily: "'DM Serif Display', serif", textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '16px' }}>Contact</div>
              {[
                { icon: <Phone size={14} color={C.coral} />, text: '+27 61 391 1942', href: 'tel:+27613911942' },
                { icon: <Mail size={14} color={C.coral} />, text: 'info@grandgatherregistry.co.za', href: 'mailto:info@grandgatherregistry.co.za' },
                { icon: <MapPin size={14} color={C.coral} />, text: 'South Africa' },
              ].map((c, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '14px', color: 'rgba(255,255,255,0.4)', marginBottom: '12px' }} className='footer-contact-item'>
                  <span style={{ marginTop: '3px', flexShrink: 0 }}>{c.icon}</span>
                  {c.href ? <a href={c.href} style={{ color: 'rgba(255,255,255,0.4)', textDecoration: 'none', transition: 'color 0.2s' }}>{c.text}</a> : <span>{c.text}</span>}
                </div>
              ))}
            </div>
          </div>

          <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '24px', textAlign: 'center' }} className='footer-bottom'>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', marginBottom: '10px', flexWrap: 'wrap' }}>
              {['Terms', 'Privacy', 'Cookies'].map(l => (
                <a key={l} href={`/${l.toLowerCase()}`} style={{ fontSize: '13px', color: 'rgba(255,255,255,0.25)', textDecoration: 'none', transition: 'color 0.2s' }}>{l}</a>
              ))}
            </div>
            <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.25)' }}>Made with <span style={{ color: C.coral }}>♥</span> &middot; &copy; 2026. All rights reserved.</div>
          </div>
        </div>
      </footer>

      {/* GIGI NOTIFICATION POPUP */}
      {gigiNotif && (
        <div style={{
          position: 'fixed',
          bottom: '104px',
          right: '28px',
          zIndex: 998,
          width: '300px',
          background: 'white',
          borderRadius: '20px',
          boxShadow: '0 8px 40px rgba(0,0,0,0.18), 0 2px 12px rgba(227,66,92,0.12)',
          border: '1px solid rgba(227,66,92,0.15)',
          overflow: 'hidden',
          animation: 'notifSlideIn 0.5s cubic-bezier(0.16,1,0.3,1) both',
        }}>
          {/* Header strip */}
          <div style={{
            background: 'white',
            padding: '16px 18px 14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src='/gigi-mascot.png' alt='GiGi' style={{ width: '36px', height: '36px', borderRadius: '50%', border: '2px solid rgba(227,66,92,0.2)', objectFit: 'contain' }} />
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#10B981', boxShadow: '0 0 6px rgba(16,185,129,0.6)', animation: 'gigiDotFlicker 3.5s ease-in-out infinite' }} />
                  <span style={{ fontSize: '10px', fontWeight: 700, color: '#10B981', letterSpacing: '0.05em' }}>Online</span>
                </div>
                <div style={{ fontSize: '15px', fontWeight: 700, color: '#1c1c1e', lineHeight: 1.1, marginTop: '2px' }}>Hi! I'm GiGi</div>
              </div>
            </div>
            <button onClick={() => setGigiNotif(false)} style={{ background: 'rgba(0,0,0,0.05)', border: 'none', color: '#666', width: '40px', height: '40px', borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', transition: 'background 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.1)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(0,0,0,0.05)'}
              aria-label="Close notification">×</button>
          </div>
          {/* Body */}
          <div style={{ padding: '16px 18px 18px' }}>
            <div style={{ fontSize: '13px', color: '#444', lineHeight: 1.6, marginBottom: '14px', fontWeight: 500 }}>
              Your AI event planning assistant. Let's create something beautiful!
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Link to='/register' onClick={() => setGigiNotif(false)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '11px 16px', borderRadius: '12px', background: C.coral, color: 'white', fontSize: '14px', fontWeight: 600, textDecoration: 'none', transition: 'all 0.2s', boxShadow: '0 2px 10px rgba(227,66,92,0.25)' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(227,66,92,0.35)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 2px 10px rgba(227,66,92,0.25)'; }}>
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><path d='M12 5v14M5 12l7 7 7-7'/></svg>
                Start Your Event
              </Link>
              <Link to='/register/vendor' onClick={() => setGigiNotif(false)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '11px 16px', borderRadius: '12px', background: 'rgba(28,28,30,0.06)', color: C.charcoal, fontSize: '14px', fontWeight: 600, textDecoration: 'none', border: '1.5px solid rgba(0,0,0,0.08)', transition: 'all 0.2s' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(28,28,30,0.1)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(28,28,30,0.06)'; e.currentTarget.style.transform = ''; }}>
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'/><circle cx='9' cy='7' r='4'/><path d='M23 21v-2a4 4 0 0 0-3-3.87'/><path d='M16 3.13a4 4 0 0 1 0 7.75'/></svg>
                Become a Vendor
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* COOKIE CONSENT BANNER */}
      {!cookieConsent && (
        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          background: C.charcoal,
          borderTop: '1px solid rgba(255,255,255,0.08)',
          padding: '16px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
          flexWrap: 'wrap',
          boxShadow: '0 -4px 24px rgba(0,0,0,0.3)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px', color: 'rgba(255,255,255,0.85)', lineHeight: 1.5 }}>
            <span style={{ fontSize: '20px' }}>🍪</span>
            <span>
              This site uses cookies to keep you logged in and improve your experience.
              By continuing, you agree to our{' '}
              <Link to="/cookies" style={{ color: C.coral, textDecoration: 'underline', fontWeight: 600 }}>Cookie Policy</Link>.
            </span>
          </div>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <Link to="/cookies" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.6)', textDecoration: 'none', padding: '8px 14px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.15)', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)'; e.currentTarget.style.color = 'rgba(255,255,255,0.9)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)'; e.currentTarget.style.color = 'rgba(255,255,255,0.6)'; }}>
              Learn More
            </Link>
            <button onClick={acceptCookies} style={{
              padding: '8px 20px',
              borderRadius: '6px',
              border: 'none',
              background: C.coral,
              color: 'white',
              fontSize: '13px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 2px 8px rgba(227,66,92,0.3)',
            }}
              onMouseEnter={e => { e.currentTarget.style.background = C.coralDark; e.currentTarget.style.transform = 'translateY(-1px)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = C.coral; e.currentTarget.style.transform = ''; }}>
              Accept
            </button>
          </div>
        </div>
      )}

      {/* GIGI FAB */}
      {!gigiOpen && (
      <button onClick={() => { sessionStorage.removeItem('gigi_dismissed_global'); setGigiOpen(true); playNotificationSound(); }} style={{ position: 'fixed', bottom: '28px', right: '28px', zIndex: 999, width: '60px', height: '60px', borderRadius: '50%', background: 'transparent', border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.2)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.3s', overflow: 'visible', padding: 0 }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.06)'; e.currentTarget.style.boxShadow = '0 8px 28px rgba(0,0,0,0.25)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.2)'; }}
        aria-label='Chat with GiGi' className='gigi-fab'>
        <img src='/gigi-mascot.png' alt='GiGi' style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'contain' }} />
        <div style={{ position: 'absolute', bottom: '2px', right: '2px', width: '12px', height: '12px', borderRadius: '50%', background: '#10B981', border: '2px solid white', animation: 'gigiDotFlicker 3.5s ease-in-out infinite' }} />
      </button>
      )}

      {/* GIGI LANDING PANEL */}
      {gigiOpen && (
        <div style={{
          position: 'fixed',
          bottom: '104px',
          right: '28px',
          zIndex: 998,
          width: '300px',
          background: 'white',
          borderRadius: '20px',
          boxShadow: '0 8px 40px rgba(0,0,0,0.18), 0 2px 12px rgba(227,66,92,0.12)',
          border: '1px solid rgba(227,66,92,0.15)',
          overflow: 'hidden',
          animation: 'notifSlideIn 0.5s cubic-bezier(0.16,1,0.3,1) both',
        }}>
          {/* Header */}
          <div style={{
            background: 'white',
            padding: '16px 18px 14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src='/gigi-mascot.png' alt='GiGi' style={{ width: '36px', height: '36px', borderRadius: '50%', border: '2px solid rgba(227,66,92,0.2)', objectFit: 'contain' }} />
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#10B981', boxShadow: '0 0 6px rgba(16,185,129,0.6)', animation: 'gigiDotFlicker 3.5s ease-in-out infinite' }} />
                  <span style={{ fontSize: '10px', fontWeight: 700, color: '#10B981', letterSpacing: '0.05em' }}>Online</span>
                </div>
                <div style={{ fontSize: '15px', fontWeight: 700, color: '#1c1c1e', lineHeight: 1.1, marginTop: '2px' }}>Hi! I'm GiGi</div>
              </div>
            </div>
            <button onClick={() => setGigiOpen(false)} style={{ background: 'rgba(0,0,0,0.05)', border: 'none', color: '#666', width: '40px', height: '40px', borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', transition: 'background 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.1)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(0,0,0,0.05)'}
              aria-label="Close">×</button>
          </div>
          {/* Body */}
          <div style={{ padding: '16px 18px 18px' }}>
            <div style={{ fontSize: '13px', color: '#444', lineHeight: 1.6, marginBottom: '14px', fontWeight: 500 }}>
              Your AI event planning assistant. Let's create something beautiful!
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Link to='/register' onClick={() => setGigiOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '11px 16px', borderRadius: '12px', background: C.coral, color: 'white', fontSize: '14px', fontWeight: 600, textDecoration: 'none', transition: 'all 0.2s', boxShadow: '0 2px 10px rgba(227,66,92,0.25)' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(227,66,92,0.35)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 2px 10px rgba(227,66,92,0.25)'; }}>
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><path d='M12 5v14M5 12l7 7 7-7'/></svg>
                Start Your Event
              </Link>
              <Link to='/register/vendor' onClick={() => setGigiOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '11px 16px', borderRadius: '12px', background: 'rgba(28,28,30,0.06)', color: C.charcoal, fontSize: '14px', fontWeight: 600, textDecoration: 'none', border: '1.5px solid rgba(0,0,0,0.08)', transition: 'all 0.2s' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(28,28,30,0.1)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(28,28,30,0.06)'; e.currentTarget.style.transform = ''; }}>
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'><path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2'/><circle cx='9' cy='7' r='4'/><path d='M23 21v-2a4 4 0 0 0-3-3.87'/><path d='M16 3.13a4 4 0 0 1 0 7.75'/></svg>
                Become a Vendor
              </Link>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>
  );
}